import TyreFilter from './tyre-filter';

function ExclusiveTyreFilter(properties, filter) {
  TyreFilter.call(this, properties, filter);
}

ExclusiveTyreFilter.prototype = Object.create(TyreFilter.prototype);

Object.assign(ExclusiveTyreFilter.prototype, {
  constructor: ExclusiveTyreFilter,

  activate: function () {
    this._group.deactivate();
    this._active = true;
  },
});

export default ExclusiveTyreFilter;
